import React, { useState, useEffect } from "react";
import { Card, Typography, Slider, Button, Skeleton } from "antd";

const { Title, Text } = Typography;

const PriceFilter = ({ onFilter }) => {
  const [range, setRange] = useState([10, 20]);
  const [loading, setLoading] = useState(true);  // Add loading state

  const handleSliderChange = (value) => {
    setRange(value);
  };

  const handleFilter = () => {
    if (onFilter) {
      onFilter(range);
    }
  };

  useEffect(() => {
    // Simulating a loading delay
    const timer = setTimeout(() => {
      setLoading(false);  // Switch off loading after 2 seconds
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div style={{ padding: "0px 16px 16px 16px", border: "1px solid #ddd", borderRadius: 8 }}>
      <div style={{ marginTop: 24 }}>
        {loading ? (
          // Skeleton for Slider
          <Skeleton.Input style={{ width: '100%', height: 40 }} active />
        ) : (
          <Slider
            range
            min={0}
            max={100}
            step={1}
            defaultValue={range}
            value={range}
            onChange={handleSliderChange}
            trackStyle={[{ backgroundColor: 'rgb(17, 152, 17)', height: 4 }]}
            handleStyle={[{ borderColor: 'gold', backgroundColor: 'gold' }, { borderColor: 'gold', backgroundColor: 'rgb(17, 152, 17)' }]}
            railStyle={{ backgroundColor: '#eee', height: 4 }}
          />
        )}
      </div>

      <div style={{ marginTop: 16, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        {loading ? (
          // Skeleton for Price Text
          <Skeleton.Input style={{ width: 120, height: 20 }} active />
        ) : (
          <Text strong style={{ fontSize: "16px" }}>
            Price: ${range[0]} — ${range[1]}
          </Text>
        )}

        {loading ? (
          // Skeleton for Button
          <Skeleton.Button style={{ width: 80, height: 40 }} active />
        ) : (
          <Button type="default" onClick={handleFilter}>
            FILTER
          </Button>
        )}
      </div>
    </div>
  );
};

export default PriceFilter;
